import { render } from "./ProductDescription.vue?vue&type=template&id=91026bbe"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"

import "./ProductDescription.vue?vue&type=style&index=0&id=91026bbe&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__